import React from 'react';
import FormRow from '../../../../common/formComponents/FormRow/FormRow';
import CheckboxField from '../../../../common/formComponents/CheckboxField/CheckboxField';
import { fieldNames } from '../constants';

const IncludeWeekendRow = ({ form }) => {
  return (
    <FormRow>
      <CheckboxField
        name={fieldNames.includeWeekend}
        form={form}
        options={{ initialValue: false }}
        text="Включить выходные дни"
      />
    </FormRow>
  );
};

export default IncludeWeekendRow;
